import { JSX } from 'react';
import { FindADoctor } from '@ahc-digital/component-library';
import { S01FindADoctorProps } from './S01FindADoctor.types';
import { CreateFindADoctorModel } from './S01FindADoctor.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { useEffect, useState } from 'react';
import { fetchSpecialityList } from 'src/shared/ReputationLocatorApi.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { LayoutServiceDataExtensions } from 'src/shared/shared.types';
import { GetGoogleMapAPI } from 'src/shared/GoogleMap.service';

const Default = (props?: S01FindADoctorProps): JSX.Element => {
  const { googleMapsAPIKey = '' } = props || {};
  const context = useCustomSitecoreContext();
  const reputationDoctorSearchID = context?.reputationDoctorSearchID?.value;
  const [options, setOptions] = useState({});
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  useEffect(() => {
    async function fetchOptions() {
      try {
        const response = reputationDoctorSearchID
          ? await fetchSpecialityList(
              reputationDoctorSearchID,
              props?.fields?.FilterType?.value ?? ''
            )
          : {};
        setOptions(response);
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    }
    fetchOptions();
  }, [reputationDoctorSearchID, props?.fields?.FilterType?.value]);

  const doctorSearchURL: string = context?.doctorSearchURL?.value ?? '';

  return (
    <FindADoctor
      {...CreateFindADoctorModel(props, doctorSearchURL, options)}
      className={translationClasses(props?.params)}
      googleMapsAPIKey={googleMapsAPIKey}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<S01FindADoctorProps>(Default);

export const getServerSideProps: GetServerSideComponentProps = async (_rendering, layoutData) => {
  const context = layoutData.sitecore.context as LayoutServiceDataExtensions['context'];
  return {
    googleMapsAPIKey: GetGoogleMapAPI(context?.envVariableNameForGoogleMapAPI?.value || ''),
  };
};
